import {
  REQUEST_SOCIAL_PAGES_SUCCESS,
  REQUEST_SOCIAL_PAGES_FAILURE
} from '../constants/actionTypes';

const INITIAL_STATE = { id: null, error: null };

export default function socialPage(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_SOCIAL_PAGES_SUCCESS:
      return {
        id: parseInt(action.payload.data.id, 10),
        error: null
      };
    case REQUEST_SOCIAL_PAGES_FAILURE:
      return {
        ...state,
        id: null,
        error: action.payload.message
      };
    default:
      return state;
  }
}
